import { AppState } from '../index';

export function getMessagesSelector(state: AppState){
   return state.messages
}